export const SOCKET_SERVER = undefined;


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./app/_enviroment/prod.env.ts